module.exports = __webpack_public_path__ + "static/station-eleven-a0ff34916ded6a6326cc42266182091a.jpg";